/**
 * Runs of Formant-managed workflows (e.g. the Daily Brief gather) carry
 * org-wide data gathered as the org's admin identity, so the API returns
 * `{ redacted: 'managed-workflow' }` in place of a run's `input` / `output`
 * and a node execution's `input` / `output` / `trace` unless the caller may
 * inspect them (superuser / FDE). (DEV-17471.)
 */
export function isManagedRunRedaction(value: unknown): boolean {
  return (
    value !== null &&
    typeof value === 'object' &&
    !Array.isArray(value) &&
    (value as { redacted?: unknown }).redacted === 'managed-workflow' &&
    Object.keys(value).length === 1
  );
}
